// extracted by mini-css-extract-plugin
export default {"statuses":"Info_statuses__rrQL+"};